module.exports = __webpack_public_path__ + "static/SocialDrop-3-dark-273c50dfa88b87e4b7e074697742aefa.svg";